// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import snackbar from './snackbar';
import calendar from './calendar';
import color from './color';
import country from './country';
import venue from './venue';
import venueType from './venue-type';
import city from './city';
import team from './team';
import jobTitle from './job-title';
import contactType from './contact-type';
import contactCategory from './contact-category';
import event from './event';
import contact from './contact';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
    menu,
    snackbar,
    calendar,
    country,
    venue,
    venueType,
    city,
    team,
    color,
    jobTitle,
    contactType,
    contactCategory,
    event,
    contact,
});

export default reducers;
